import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { BrowserRouter } from 'react-router-dom' // BrowserRouter is here

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter> {/* This provides the Router context */}
    <App /> {/* App should NOT have another BrowserRouter */}
  </BrowserRouter>
)